import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
@Pipe({ name: 'dateMessage', standalone: true })
export class DateMessagePipe implements PipeTransform {
    transform(value: Date | null | ''): string {
        return value === null || value === '' ? 'No Date Available' : formatDate(value, 'MM/dd/yyyy', 'en-US');
    }
}
